import React from "react";

import {
  FIELD_TYPE,
  FORMAT_TIME,
  tabKeys,
  TT_PHIEU_KHO,
  TT_PHIEU_VTYT,
} from "types/enums";

import {DataFormField} from "types/models/input-field-type";

import {ColumnProps} from "../../../../../types/models";
import dayjs from "dayjs";

const {INPUT, DATE, COMBO_BOX, AUTO_COMPLETE, CODE, NUMBER} = FIELD_TYPE;
const listMonths = [];
for (let month = 1; month <= 12; month++) {
  listMonths.push({
    value: month,
    label: `Tháng ${month}`,
  });
}

//--------------------------------------------------------
const listYears = [];
const currentYear = new Date().getFullYear();
const startYear = 2020;
const endYear = currentYear + 100;
for (let year = startYear; year <= endYear; year++) {
  listYears.push({
    value: year,
    label: year.toString(),
  });
}
const allColumns: ColumnProps[] = [
  {
    title: "STT",
    key: "index",
    show: true,
    dataIndex: "index",
    render(_, __, index) {
      return <>{index + 1}</>;
    },
    fixed: "left",
    width: 50,
    align: "center",
    isResizable: true,
  },
  {
    title: "Mã biểu thuế",
    key: "maBieuThue",
    dataIndex: "maBieuThue",
    isResizable: true,
    align: "left",
  },
  {
    title: "Thời gian áp dụng từ",
    key: "thoiGianApDungTu",
    dataIndex: "thoiGianApDungTu",
    isResizable: true,
    align: "center",
    render: (v, r, idx) => v !== null ? dayjs(v).format("DD/MM/YYYY") : null ,
  },
  {
    title: "Thời gian áp dụng đến",
    key: "thoiGianApDungDen",
    show: true,
    dataIndex: "thoiGianApDungDen",
    align: "center",
    isResizable: true,
    render: (v, r, idx) => v !== null ? dayjs(v).format("DD/MM/YYYY") : null ,
  },

  {
    title: "Thao tác",
    dataIndex: "action",
    show: true,
    align: "center",
    fixed: "right",
    width: 160,
    key: "action",
  },
];

const itemsInputField: DataFormField[] = [
  {
    type: COMBO_BOX,
    name: "thang",
    label: "Tháng",
    disable: false,

    options: listMonths,

  },
  {
    type: COMBO_BOX,
    name: "nam",
    label: "Năm",
    disable: false,

    options: listYears,

  },
];

export {allColumns, itemsInputField};
